import classNames from "classnames";
import React from "react";
import { DoorIconProps } from "./DeKaap";

export const DeMaas: React.FC<DoorIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width={28}
      height={60}
      viewBox="0 0 28 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={classNames("gg-transition gg-duration-150 gg-ease-in-out", {
          "gg-fill-[#292747]": isActive,
          "gg-fill-[#9493A3]": !isActive,
        })}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2H25.2727V58H2V46.887C10.7231 45.8945 17.5 38.4887 17.5 29.5C17.5 20.5113 10.7231 13.1055 2 12.113V2ZM2 45.88V13.12C10.1695 14.1071 16.5 21.0643 16.5 29.5C16.5 37.9357 10.1695 44.8929 2 45.88ZM0 12V0H27.2727V60H0V47V12Z"
        fill="currentColor"
      />
    </svg>
  );
};
